var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDbSync = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_10904)",
    fill: "#8D939C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14.919C20 15.0789 19.895 15.2168 19.7496 15.264L16.3708 16.3708L15.264 19.7496C15.216 19.895 15.0783 20 14.919 20C14.7632 20 14.6324 19.902 14.5815 19.7677L11.678 12.1461C11.6591 12.1057 11.6522 12.0626 11.6522 12.0152C11.6522 11.8156 11.8156 11.6522 12.0152 11.6522C12.0626 11.6522 12.1057 11.6591 12.1461 11.678L19.7683 14.5815C19.902 14.6317 20 14.7624 20 14.919Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 17.9131C7.12075 17.9131 4 14.7923 4 10.9565C4 7.12075 7.12075 4 10.9565 4C14.7923 4 17.9131 7.12075 17.9131 10.9565C17.9131 11.0602 17.9123 11.1639 17.904 11.2682C17.8733 11.6515 17.5485 11.9395 17.1554 11.9068C16.7729 11.8769 16.487 11.5415 16.5169 11.1582C16.5224 11.0915 16.5217 11.024 16.5217 10.9565C16.5217 7.88795 14.025 5.39135 10.9565 5.39135C7.88795 5.39135 5.39135 7.88795 5.39135 10.9565C5.39135 14.025 7.88795 16.5217 10.9565 16.5217C11.0234 16.5224 11.0984 16.5224 11.1681 16.5175C11.5534 16.4926 11.8852 16.7756 11.9137 17.159C11.943 17.5423 11.6557 17.8761 11.2724 17.9047C11.1701 17.9123 11.0588 17.9131 10.9565 17.9131Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_10904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDbSync);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_db_sync.75c8148d5a02da4defe1a4b2b273c5c4.svg";